import { Button } from '@shared/components/ui';
import { useTranslation } from 'react-i18next';

interface ErrorStateProps {
  error: Error;
  onRetry: () => void;
  className?: string;
}

export const ErrorState = ({ error, onRetry, className = 'h-64' }: ErrorStateProps) => {
  const { t } = useTranslation('relocationsModule');

  return (
    <div className={`flex items-center justify-center ${className}`}>
      <div className="text-center px-4">
        <div className="text-bright-error text-4xl mb-4" aria-hidden>
          ⚠
        </div>
        <h3 className="text-lg font-semibold text-title mb-2">{t('error.title')}</h3>
        <p className="text-subtext mb-4">{error.message}</p>
        <Button variant="primary" size="sm" onClick={onRetry} data-testid="relocations-error-retry">
          {t('error.retry')}
        </Button>
      </div>
    </div>
  );
};
